module.exports = __webpack_public_path__ + "img/ventilador.3f82580b.svg";